/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { AnnouncementTable } from '../../../features/announcements/components/announcement-table';
import { Permission } from '../../../features/common/permision';

export const Route = createFileRoute('/_creator-center/admin/announcements')({
  pendingComponent: () => null,
  staticData: { permissions: [Permission.系统设置] },
  component: Announcements,
});

function Announcements() {
  return <AnnouncementTable />;
}
